// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 290) return "bundles/lab/css/lab.print.css";
	if (chunkId === 208) return "bundles/lab/css/lab.css";
	if (chunkId === 533) return "bundles/lab/lab.css";
	// return url for filenames based on template
	return "bundles/lab/" + ({"165":"robot-light","181":"robot-blockly","299":"marker-v-barchart","397":"robot-code","457":"coding-problem-info-pastes","526":"problem","712":"coding-problem-blockly"}[chunkId] || chunkId) + ".css";
};